import React from 'react';
import { Box, useTheme } from '@mui/material';
import { important, sxToObject } from '../../../utils/global/helper';
import DropdownMenu from '../DropdownMenu';

function TableDropdownMenu(props: React.ComponentProps<typeof DropdownMenu>) {
  const theme = useTheme();

  return (
    <Box display="flex" justifyContent="end">
      <DropdownMenu
        {...props}
        button={{
          sx: {
            // eslint-disable-next-line react/destructuring-assignment
            ...sxToObject(props.button?.sx, theme),
            padding: important(theme.spacing(1)),
          },
        }}
      />
    </Box>
  );
}

export default TableDropdownMenu;
